import { useNavigate } from 'react-router-dom'
import { isEqual } from 'date-fns'

import { Log } from '@/types/logs'
import { useWorkstationStore } from '@/modules/Workstation/store'
import { useWorkstationSelect } from '@/modules/Workstation/hooks/useWorkstationSelect'
import { useDateStore } from '@/components/DateInput'
import { ROUTES } from '@/router'

import styles from './UnfinishedLogsTable.module.scss'
import { UnfinishedLogsControllerTab } from '@/modules/CombinedLogs/ui/UnfinishedLogsControllerTab'

export const UnfinishedLogsTable = () => {
    const { workstation } = useWorkstationStore()
    const { date, setDate } = useDateStore()
    const { handleWorkstationChange } = useWorkstationSelect()
    const navigate = useNavigate()

    const handleNavigateToLog = (log: Log) => {
        if (log.workstation !== workstation?.workstationNumber) {
            handleWorkstationChange(log.workstation)
        }

        if (!isEqual(log.timestamp, date)) {
            setDate(new Date(log.timestamp))
        }

        navigate(ROUTES.HOME)
    }

    return (
        <div className={styles.root}>
            <UnfinishedLogsControllerTab
                displayTableHeader
                displayEmptyPlaceholder
                actionCallback={handleNavigateToLog}
            />
        </div>
    )
}
